var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.498 18.865a7.889 7.889 0 0 1-5.814 8.641v1.618a2.001 2.001 0 0 1-3.419 1.416 2.001 2.001 0 0 1-.587-1.416v-3.355a2.001 2.001 0 0 1 2.001-2.002v-.016a3.872 3.872 0 1 0-3.658-5.158 1.975 1.975 0 0 1-1.873 1.288 2.012 2.012 0 0 1-1.882-2.707 7.884 7.884 0 0 1 15.221 1.691h.01zM24.857 37.197a2.396 2.396 0 1 0 0-4.792 2.396 2.396 0 0 0 0 4.792zM45.617 25.63a4.965 4.965 0 0 1-5.895 2.874l-.522.886a1.262 1.262 0 0 1-2.182-1.265l1.06-1.829a1.262 1.262 0 0 1 1.723-.46 2.438 2.438 0 1 0-.348-3.971 1.244 1.244 0 0 1-1.426.11 1.267 1.267 0 0 1-.17-2.07 4.965 4.965 0 0 1 7.76 5.725zM36.422 33.411a1.508 1.508 0 1 0 0-3.015 1.508 1.508 0 0 0 0 3.015zM13.357 21.285a4.965 4.965 0 0 1-1.544 6.373l.355.959a1.262 1.262 0 0 1-2.364.878l-.737-1.986a1.262 1.262 0 0 1 .744-1.62 2.438 2.438 0 1 0-3.282-2.253 1.247 1.247 0 0 1-.825 1.17A1.268 1.268 0 0 1 4 23.619a4.965 4.965 0 0 1 9.357-2.333zM12.33 33.877a1.508 1.508 0 1 0 0-3.016 1.508 1.508 0 0 0 0 3.016z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.8b91addbb22928806a9520fbcf481c9c.svg";
export { ForwardRef as ReactComponent };